import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import O1HD from "../../../../engines/gameEngine";
import utilsModel from "../../../../engines/libs/utilsModel";
import CsvDataManage from "../../../../engines/managers/CsvDataManage";
import { CsvFileKind } from "../../../define/CsvFileKind";
import MatchMiaiWeaponSelectItem from "./MatchMiaiWeaponSelectItem";

const {ccclass, property} = cc._decorator;

@ccclass
export default class MatchMiaiWeaponSelect extends BasePopUpLayer {

    @property({type:cc.Prefab,displayName:"武器item"})
    weaponItem:cc.Prefab = null;

    @property({type:cc.Node,displayName:"itemContent"})
    itemContent:cc.Node = null;

    start(){
        this.initLayer();
    }

    initLayer(){
        let bSpecial = this._carryData.bSpecial;
        this.itemContent.removeAllChildren();
        let csvInfos = CsvDataManage.instance.getCsvData(CsvFileKind.CsvFile.MATCH_MIAI);
        let title = csvInfos.title;
        for (let i in csvInfos) {
            if (i == 'title' || i == '' || i.trim() == '') {
                continue;
            }

            let info = csvInfos[i];
            let special_type = info[title.special_type];
            if (utilsModel.isValidNumberValue(special_type)) {
                if (!bSpecial) {
                    continue;
                }
            }

            let nodeItem = cc.instantiate(this.weaponItem);
            nodeItem.active = true;
            this.itemContent.addChild(nodeItem);

            let script = nodeItem.getComponent(MatchMiaiWeaponSelectItem);
            script.setData(i, this);
        }
    }

    resumeHit() {
        this.destroyNode();
        this._carryData.resumeHit();
    }

    openBuyEquipLayer() {
        this._carryData.parent.openBuyEquipLayer();
    }

    showEuqipUI() {
        this._carryData.parent.showEuqipUI();
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.destroyNode();
    }
    
}
